import { useBackend } from "../../services";
import { IGearItem } from "./interfaces";
import { useGetPaginatedAttributes } from "../attributes/useGetPaginatedAttributes";
import { IGetPaginatedAttributeProps } from "../attributes/interfaces";
import { PageSizeHelper } from "../../models/PageSizeHelper";
import { useUser } from "../session";
import { UserRole } from "../users";
import { DataStorage } from "../../models/DataStorage";

export const useGetGearItems = (setLoading: (loading: boolean) => void) => {
  const { get } = useBackend();
  const [currentUser] = useUser.useState();
  const getGearItems = (parameters: IGetPaginatedAttributeProps) => get("gearItems", parameters);
  return useGetPaginatedAttributes<IGearItem>(
    PageSizeHelper.gearItems(currentUser?.role ?? UserRole.common),
    getGearItems,
    setLoading,
    DataStorage.gearItemStorage,
    false,
    true,
    undefined
  );
};
